var $0d47eca4edb370b0$exports = {};
$0d47eca4edb370b0$exports = {
    "alert": `\u{30A2}\u{30E9}\u{30FC}\u{30C8}`,
    "dismiss": `\u{9589}\u{3058}\u{308B}`
};


export {$0d47eca4edb370b0$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
